import React, { useEffect, useRef } from "react";
// import backgroundImage from './path/to/image.png';
import "./ImagesInfiniteScroll.css";

function ImageScroll() {
  const containerRef = useRef(null);
  useEffect(() => {
    const imageContainer = document.getElementById("image-container");
    const image = document.querySelector("#image-container img");
    let intervalDuration = 20; // set the interval duration in milliseconds (lower value will make it scroll faster)

    // reset the scroll position to 0 and restart the interval when it reaches the end
    function resetScrollPosition() {
      if (
        imageContainer.scrollTop + imageContainer.offsetHeight >=
        image.offsetHeight
      ) {
        imageContainer.scrollTop = 0;
      }
    }

    setInterval(() => {
      imageContainer.scrollTop += 1; // increase the scrollTop property to scroll down
      resetScrollPosition();
    }, intervalDuration);

    // stop the interval after 30 seconds (30000 milliseconds)
    // setTimeout(() => {
    //   clearInterval(scrollInterval);
    // }, 30000);
  }, []);

  return (
    <div className="image-scroll-container" ref={containerRef}>
      <div
        id="image-container"
        style={{
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          style={{ marginRight: "100px" }}
          src="CollegeTieUpsScrollDIAG.png"
          alt="background"
        />
      </div>
    </div>
  );
}

export default ImageScroll;
